export default "__VITE_ASSET__BJfk2Huz__"